var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('NavBar',{attrs:{"hide-on-load":true}}),_c('HeroSection'),_c('AboutSection'),_c('ProductsSection'),_c('NewsSection'),_c('ContactSection'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }